



import { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import "./app.css";

import men from "./assets/menicon.png";
import women from "./assets/womenicon.png";
import anu from "./assets/anu.jpg";
import manisha from "./assets/manisha.jpg";
import shekar from "./assets/shekar.png";
import madhus from "./assets/madhus.jpg";
import ganesh from "./assets/ganesh.jpg";
import anusha from "./assets/anusha.jpg";
import kalyan from "./assets/kalyan.jpg";
import giri from "./assets/giri.jpg";
import umesh from "./assets/umesh.jpg";
import pranayini from "./assets/pranayini.jpg";
import badri from "./assets/badri.png";
import vamsi from "./assets/vamsi.jpg";
import venky from "./assets/venky.jpg";
import hari from "./assets/Hari.jpg";
import tharun from "./assets/tharun.jpg";
import nithish from "./assets/nithish.jpg";
import indhumathi from "./assets/indhumathi.jpg";
import jayanthi from "./assets/jayanthi.jpg";
import mahalakshmi from "./assets/mahalakshmi.jpg";
import aneesha from "./assets/aneesha.jpg";

const CARD_THEMES = [
  "theme-mauve",
  "theme-pink",
  "theme-sage",
  "theme-coral",
  "theme-sand",
  "theme-blue",
];

const profiles = [
  {
    id: 1,
    name: "Ganesh Sabavath",
    designation: "Director",
    label: "Director",
    bio: "Provides strategic leadership, oversees company operations, drives business growth, ensures regulatory compliance, and guides long-term vision and decision-making.",
    img: ganesh,
    projects: [
      { title: "Representation & Public Relations" },
      { title: "Team Leadership" },
      { title: "Legal & Compliance Responsibilities" },
      { title: "Strategic Planning" },
    ],
  },
  {
    id: 3,
    name: "A. Manisha",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Analyzes user behavior and product performance to drive data-informed business decisions.",
    img: manisha,
    projects: [
      { title: "Loanera" },
      { title: "CM Cheyutha" },
      { title: "SheRide" },
      { title: "Vivekananda Trust", link: "https://vivekanandamissiontrust.com/" },
      { title: "Katha Mitra" },
      { title: "Bliss Sierra" },
      { title: "Funzy Code", link: "https://funzycode.com" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 4,
    name: "Anu Komarabathini",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, tests, and maintains software applications, collaborates with cross-functional teams, writes clean and efficient code, troubleshoots issues, and ensures scalable and secure solutions.",
    img: anu,
    projects: [
      { title: "Bliss Sierra", link: "https://blisssierra.com/" },
      { title: "Ridebuzz" },
      { title: "CM Cheyutha" },
      { title: "Loanera" },
      { title: "BeautyBee" },
      { title: "Bliss Decor" },
      { title: "Local Service" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 5,
    name: "K.Maha Lakshmi",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Coordinates cross-functional teams and ensures projects are delivered on time and budget.",
    img: mahalakshmi,
    projects: [
      { title: "CM Cheyutha" },
      { title: "HRMS" },
      { title: "Trip Planner" },
      { title: "My Memory Preserved" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 6,
    name: "M. Pranayini",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, tests, and maintains software applications, collaborates with cross-functional teams, writes clean and efficient code, troubleshoots issues, and ensures scalable and secure solutions.",
    img: pranayini,
    projects: [
      { title: "Financial Services Website" },
      { title: "E-commerce Website" },
      { title: "MyMediApp" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 7,
    name: "G. Jayanthi",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, tests, and maintains software applications, collaborates with cross-functional teams, writes clean and efficient code, troubleshoots issues, and ensures scalable and secure solutions.",
    img: jayanthi,
    projects: [{ title: "To Do List" }],
  },

    {
    id: 8,
    name: "K.Aneesha",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, tests, and maintains software applications, collaborates with cross-functional teams, writes clean and efficient code, troubleshoots issues, and ensures scalable and secure solutions.",
    img: aneesha,
    projects: [{ title: "To Do List" }],
  },
  {
    id: 9,
    name: "V. Venkata Ramudu",
    designation: "Digital Media Manager",
    label: "Media",
    bio: "Handles digital campaigns, social media management, account management, content strategy, paid promotions, and performance analytics.",
    img: venky,
    projects: [
      { title: "Accounts Management" },
      { title: "Content Strategy & Creatives" },
      { title: "Social Media Management" },
      { title: "Networking" },
      { title: "Photo Editing" },
    ],
  },
  {
    id: 10,
    name: "A. Hari Prasad",
    designation: "Business Development Officer",
    label: "Business",
    bio: "Expert in UX/UI, responsible for the aesthetic and functional design of all digital products.",
    img: hari,
    projects: [
      { title: "Loanera" },
      { title: "Bliss Christian Matrimony" },
      { title: "CM Cheyutha" },
    ],
  },
  {
    id: 11,
    name: "Vamsi Ediga",
    designation: "Chief Technology Officer",
    label: "CTO",
    bio: "Leads our iOS and Android development teams, focusing on performance and user experience.",
    img: vamsi,
    projects: [
      { title: "CM Cheyutha-AP" },
      { title: "CM Cheyutha-UP" },
      { title: "Flamwingo" },
      { title: "Bliss Parinayam Matrimony" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 12,
    name: "Y. Raja Shekar",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Creates clear, concise, and accurate documentation for both internal and external users.",
    img: shekar,
    projects: [
      { title: "Loanera" },
      { title: "CM Cheyutha" },
      { title: "E-commerce" },
      { title: "Biryani Restaurant" },
      { title: "Dry Fruits Hub" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 13,
    name: "S Y S Madhu Kumar",
    designation: "Team Leader",
    label: "Leader",
    bio: "Protects our systems and data from threats, maintaining compliance standards.",
    img: madhus,
    projects: [
      { title: "CM Cheyutha" },
      { title: "Loanera" },
      { title: "Bliss Sierra" },
      { title: "Grocery" },
      { title: "HRMS", link: "https://hrms-23aed.web.app" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 14,
    name: "B. Pedda Obaiah",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, tests, and maintains software applications, writes clean and efficient code, and ensures scalable and secure solutions.",
    img: badri,
    projects: [
      { title: "Dino World Park" },
      { title: "Super Market Retail Billing" },
      { title: "CM Cheyutha" },
      { title: "Billing And Invoice" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 15,
    name: "V. Tharun",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, and maintains software applications, writes clean and efficient code, and ensures scalable and secure solutions.",
    img: tharun,
    projects: [
      { title: "VR Headsets Ecommerce Website" },
      { title: "Financial Services Website" },
      { title: "V-Care Hospital Project" },
      { title: "T-Max Countdown Project" },
      { title: "Gaming Project" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 16,
    name: "G. Umesh",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Passionate about modern JavaScript frameworks and pixel-perfect implementation.",
    img: umesh,
    projects: [
      { title: "User Management App" },
      { title: "Counsellor's Portal" },
      { title: "Financial Services Website" },
      { title: "Bliss Gated Community" },
      { title: "Ridhavor Project" },
    ],
  },
  {
    id: 17,
    name: "G. Giridhar",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, and maintains software applications, writes clean and efficient code, and ensures scalable and secure solutions.",
    img: giri,
    projects: [
      { title: "Financial Services Website" },
      { title: "Siera-Bean Coffee Shop" },
      { title: "HRMS" },
      { title: "Bliss Gated Community" },
    ],
  },
  {
    id: 18,
    name: "P. Kalyan",
    designation: "Junior Frontend Developer",
    label: "Engineer",
    bio: "Junior Frontend Developer passionate about creating clean, responsive user interfaces using HTML, CSS, JavaScript, and React.",
    img: kalyan,
    projects: [
      { title: "Financial Services Website" },
      { title: "Annapoorna Restaurant App" },
      { title: "Bliss Gated Community" },
    ],
  },

    {
    id: 19,
    name: "K.Nithish",
    designation: "Software Engineer",
    label: "Engineer",
    bio: "Designs, develops, and maintains software applications, writes clean and efficient code, and ensures scalable and secure solutions.",
    img: nithish,
    projects: [
      { title: "Financial Services Website" },
      { title: "Siera-Bean Coffee Shop" },
      { title: "HRMS" },
      { title: "Bliss Gated Community" },
    ],
  },



];

/* ─────────────────────────────────────────
   WebGL background — floating particles
───────────────────────────────────────── */
function WebGLBackground({ canvasRef }) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const gl = canvas.getContext("webgl");
    if (!gl) return;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      gl.viewport(0, 0, canvas.width, canvas.height);
    };
    resize();
    window.addEventListener("resize", resize);

    const vsrc = `
      attribute vec4 pos;
      attribute float alpha;
      uniform float time;
      uniform mat4 proj;
      varying float vAlpha;
      void main(){
        vec4 p = pos;
        p.y += sin(time * 0.6 + pos.x * 2.0) * 18.0;
        p.x += cos(time * 0.4 + pos.z * 1.5) * 12.0;
        gl_Position = proj * p;
        gl_PointSize = max(1.5, 3.0 - gl_Position.z * 0.002);
        vAlpha = alpha;
      }
    `;
    const fsrc = `
      precision mediump float;
      varying float vAlpha;
      void main(){
        vec2 c = gl_PointCoord - 0.5;
        float d = dot(c, c);
        if(d > 0.25) discard;
        gl_FragColor = vec4(0.95, 0.55, 0.15, vAlpha * (1.0 - d * 4.0));
      }
    `;

    const makeShader = (type, src) => {
      const s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return s;
    };
    const prog = gl.createProgram();
    gl.attachShader(prog, makeShader(gl.VERTEX_SHADER, vsrc));
    gl.attachShader(prog, makeShader(gl.FRAGMENT_SHADER, fsrc));
    gl.linkProgram(prog);
    gl.useProgram(prog);

    const N = 450;
    const positions = new Float32Array(N * 3);
    const alphas = new Float32Array(N);
    for (let i = 0; i < N; i++) {
      positions[i * 3] = (Math.random() - 0.5) * window.innerWidth * 1.8;
      positions[i * 3 + 1] = (Math.random() - 0.5) * window.innerHeight * 1.8;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 700 - 100;
      alphas[i] = 0.06 + Math.random() * 0.24;
    }

    const pb = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, pb);
    gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);
    const pLoc = gl.getAttribLocation(prog, "pos");
    gl.enableVertexAttribArray(pLoc);
    gl.vertexAttribPointer(pLoc, 3, gl.FLOAT, false, 0, 0);

    const ab = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, ab);
    gl.bufferData(gl.ARRAY_BUFFER, alphas, gl.STATIC_DRAW);
    const aLoc = gl.getAttribLocation(prog, "alpha");
    gl.enableVertexAttribArray(aLoc);
    gl.vertexAttribPointer(aLoc, 1, gl.FLOAT, false, 0, 0);

    const uTime = gl.getUniformLocation(prog, "time");
    const uProj = gl.getUniformLocation(prog, "proj");

    const ortho = (l, r, b, t, n, f) => [
      2 / (r - l), 0, 0, 0,
      0, 2 / (t - b), 0, 0,
      0, 0, -2 / (f - n), 0,
      -(r + l) / (r - l), -(t + b) / (t - b), -(f + n) / (f - n), 1,
    ];

    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE);

    let t = 0;
    let raf;
    const frame = () => {
      t += 0.008;
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      const w = canvas.width, h = canvas.height;
      gl.uniformMatrix4fv(uProj, false, ortho(-w / 2, w / 2, -h / 2, h / 2, -1000, 1000));
      gl.uniform1f(uTime, t);
      gl.drawArrays(gl.POINTS, 0, N);
      raf = requestAnimationFrame(frame);
    };
    frame();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(raf);
    };
  }, [canvasRef]);

  return null;
}

/* ─────────────────────────────────────────
   Profile Card with 3D tilt + burst
───────────────────────────────────────── */
function ProfileCard({ profile, index, themeClass, onClick }) {
  const cardRef = useRef(null);
  const burstRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const r = card.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    card.style.transform = `perspective(900px) rotateY(${x * 22}deg) rotateX(${-y * 18}deg) translateZ(10px) scale(1.02)`;
    const shine = card.querySelector(".card-shine");
    if (shine) {
      shine.style.setProperty("--mx", `${((e.clientX - r.left) / r.width) * 100}%`);
      shine.style.setProperty("--my", `${((e.clientY - r.top) / r.height) * 100}%`);
      shine.style.opacity = "1";
    }
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (!card) return;
    card.style.transition = "transform 0.7s cubic-bezier(0.22,1,0.36,1)";
    card.style.transform = "perspective(900px) rotateY(0deg) rotateX(0deg) translateZ(0px) scale(1)";
    const shine = card.querySelector(".card-shine");
    if (shine) shine.style.opacity = "0";
    setTimeout(() => {
      if (card) card.style.transition = "transform 0.08s linear";
    }, 700);
  };

  const handleMouseEnter = () => {
    const card = cardRef.current;
    if (card) card.style.transition = "transform 0.08s linear";
  };

  const spawnBurst = (e) => {
    const burst = burstRef.current;
    const card = cardRef.current;
    if (!burst || !card) return;
    const r = card.getBoundingClientRect();
    const lx = e.clientX - r.left;
    const ly = e.clientY - r.top;
    for (let i = 0; i < 18; i++) {
      const dot = document.createElement("span");
      dot.className = "burst-dot";
      const angle = (i / 18) * 360;
      const dist = 45 + Math.random() * 65;
      dot.style.cssText = `
        left:${lx}px;top:${ly}px;
        --tx:${Math.cos((angle * Math.PI) / 180) * dist}px;
        --ty:${Math.sin((angle * Math.PI) / 180) * dist}px;
        width:${4 + Math.random() * 8}px;
        height:${4 + Math.random() * 8}px;
        animation-duration:${0.4 + Math.random() * 0.35}s;
      `;
      burst.appendChild(dot);
      setTimeout(() => dot.remove(), 900);
    }
  };

  const handleClick = (e) => {
    spawnBurst(e);
    setTimeout(() => onClick(profile), 150);
  };

  return (
    <article
      ref={cardRef}
      className={`profile-card ${themeClass}`}
      tabIndex={0}
      style={{ animationDelay: `${index * 0.065}s`, transition: "transform 0.08s linear" }}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(profile);
        }
      }}
    >
      <span className="card-index">{String(index + 1).padStart(2, "0")}</span>

      <div className="card-top-label">
        <span className="card-line"></span>
        <span>{profile.label || "Team"}</span>
      </div>

      <div className="profile-card-content">
        <h3>{profile.name}</h3>
        <p className="designation">{profile.designation}</p>
      </div>

      {/* Holographic shine overlay */}
      <div className="card-shine" />

      {/* 3D decorative ring */}
      <div className="card-3d-ring" />

      {/* Floating orb glow */}
      <div className="card-orb" />

      <div className="profile-image-wrap">
        <img
          className="profile-img"
          src={profile.img || women}
          alt={profile.name}
        />
      </div>

      {/* Particle burst container */}
      <div ref={burstRef} className="card-burst-layer" />
    </article>
  );
}

/* ─────────────────────────────────────────
   Detail Modal
───────────────────────────────────────── */
function DetailModal({ profile, onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  return (
    <div
      id="detail-view"
      onClick={(e) => { if (e.target.id === "detail-view") onClose(); }}
    >
      <div id="detail-card" role="dialog" aria-modal="true">
        <div className="detail-left">
          <button className="close-btn" onClick={onClose} aria-label="Close details">✕</button>

          <div className="detail-avatar-wrap">
            <img src={profile.img} alt={profile.name} />
            {/* Orbit ring around avatar */}
            <div className="avatar-orbit" />
          </div>

          <p className="section-mini detail-mini">Team Profile</p>
          <h3>{profile.name}</h3>
          <p className="role">{profile.designation}</p>
          <div className="bio">{profile.bio}</div>
        </div>

        <div className="detail-right">
          <div className="info-block">
            <div className="skill-chips">
              {(profile.skills || []).map((s, i) => (
                <span className="chip" key={i}>{s}</span>
              ))}
            </div>
          </div>

          <div className="info-block">
            <p className="experience-text">{profile.experience}</p>
          </div>

          <div className="info-block">
            <h4>Key Projects &amp; Contributions</h4>
            <ul id="detail-projects">
              {profile.projects?.map((proj, idx) => (
                <li key={idx} style={{ animationDelay: `${idx * 0.06}s` }}>
                  <span className="project-dot"></span>
                  <a href={proj.link} target="_blank" rel="noreferrer noopener">
                    {proj.title}
                  </a>
                </li>
              ))}
              {(!profile.projects || profile.projects.length === 0) && (
                <li className="empty-project">
                  <span>No projects added yet.</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   Loading Screen
───────────────────────────────────────── */
function LoadingScreen({ titleAnimated, titleSliding, particles }) {
  return (
    <div id="loading-screen" role="status" aria-live="polite">
      <div className="loading-bg">
        <div className="gradient-orb orb-a"></div>
        <div className="gradient-orb orb-b"></div>
        <div className="gradient-orb orb-c"></div>
        <div className="particles-layer" aria-hidden="true">
          {particles.map((p) => (
            <span key={p.id} className="particle" style={{
              width: p.size, height: p.size, left: p.left,
              animationDelay: p.delay, animationDuration: p.duration, opacity: p.opacity,
            }} />
          ))}
        </div>
      </div>
      <div className="title-wrapper">
        <h1 className={`bliss-title ${titleAnimated ? "title-reveal" : ""} ${titleSliding ? "title-sliding" : ""}`}>
          Bliss Sierra
        </h1>
        <p className={`loading-subtitle ${titleAnimated ? "subtitle-reveal" : ""}`}>
          Our Core Team Portfolios
        </p>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   Main App
───────────────────────────────────────── */
function OurTeam() {
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [titleAnimated, setTitleAnimated] = useState(false);
  const [titleSliding, setTitleSliding] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [styleIndex, setStyleIndex] = useState(0);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [menuOpen, setMenuOpen] = useState(false);

  const particles = useMemo(
    () =>
      Array.from({ length: 26 }, (_, i) => ({
        id: i,
        size: `${6 + (i % 6) * 4}px`,
        left: `${(i * 4.2) % 100}%`,
        delay: `${(i % 7) * 0.8}s`,
        duration: `${10 + (i % 5) * 2}s`,
        opacity: 0.08 + (i % 4) * 0.04,
      })),
    []
  );

  useEffect(() => {
    const revealTimeout = setTimeout(() => setTitleAnimated(true), 400);
    const slideTimeout = setTimeout(() => setTitleSliding(true), 2200);
    const mainTimeout = setTimeout(() => setLoading(false), 3100);
    return () => {
      clearTimeout(revealTimeout);
      clearTimeout(slideTimeout);
      clearTimeout(mainTimeout);
    };
  }, []);

  // Global cursor glow effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
      const glow = document.getElementById("cursor-glow");
      if (glow) {
        glow.style.left = e.clientX + "px";
        glow.style.top = e.clientY + "px";
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === "Escape") setSelectedProfile(null); };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  const goHome = () => navigate("/");

  const getThemeClass = (index) => CARD_THEMES[(index + styleIndex) % CARD_THEMES.length];

  return (
    <>
      {/* WebGL canvas */}
      <canvas
        ref={canvasRef}
        id="webgl-canvas"
        style={{
          position: "fixed", inset: 0, zIndex: 0, pointerEvents: "none",
          width: "100%", height: "100%",
        }}
      />
      <WebGLBackground canvasRef={canvasRef} />

      {/* Cursor glow */}
      <div id="cursor-glow" aria-hidden="true" />

      {loading && (
        <LoadingScreen
          titleAnimated={titleAnimated}
          titleSliding={titleSliding}
          particles={particles}
        />
      )}

      <main
        id="main-content"
        style={{ opacity: loading ? 0 : 1, visibility: loading ? "hidden" : "visible" }}
      >
        <div className="animated-bg">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
          <div className="particles-layer" aria-hidden="true">
            {particles.map((p) => (
              <span key={p.id} className="particle" style={{
                width: p.size, height: p.size, left: p.left,
                animationDelay: p.delay, animationDuration: p.duration, opacity: p.opacity,
              }} />
            ))}
          </div>
        </div>

        <div className="page-shell">
          <header className="page-header">
            <button className="floating-btn back-btn" onClick={goHome}>← Back</button>
            <div className="page-title-block">
              <p className="section-mini">Core Team Portfolios</p>
              <h2 className="page-title">Meet Our Core Team</h2>
            </div>
            <div className="header-right-btn">
              <div className="team-nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
              </div>
              <nav className={`team-nav-links${menuOpen ? " active" : ""}`}>
                <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
                <NavLink to="/Tunga-Drones" onClick={() => setMenuOpen(false)}>Tunga Drones</NavLink>
                <NavLink to="/Our-Projects" onClick={() => setMenuOpen(false)}>Our Projects</NavLink>
                <NavLink to="/Services" onClick={() => setMenuOpen(false)}>Services</NavLink>
                <NavLink to="/Careers" onClick={() => setMenuOpen(false)}>Careers</NavLink>
              </nav>
            </div>
          </header>

          <section className="network-section">
            <div className="network-line network-line-vertical"></div>
            <div className="network-dot network-dot-left"></div>
            <div className="network-dot network-dot-bottom"></div>

            <div id="portfolio-grid" aria-label="team portfolio grid">
              {profiles.map((p, index) => (
                <ProfileCard
                  key={`${p.id}-${index}`}
                  profile={p}
                  index={index}
                  themeClass={getThemeClass(index)}
                  onClick={setSelectedProfile}
                />
              ))}
            </div>
          </section>
        </div>
      </main>

      {selectedProfile && (
        <DetailModal profile={selectedProfile} onClose={() => setSelectedProfile(null)} />
      )}
    </>
  );
}

export default OurTeam;






























